import { Theme } from "@mui/material/styles";

export const getAccordionComponents = (sunoTheme: Theme) => ({
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        paddingTop: sunoTheme.spacing(4),
        paddingBottom: sunoTheme.spacing(4),
        paddingLeft: sunoTheme.spacing(5),
        paddingRight: sunoTheme.spacing(5),
      },
      content: {
        margin: 0,
      },
    },
  },
});
